// extracted by mini-css-extract-plugin
export default {"bgPrimary":"Loading_bgPrimary__ePVpj","contentLoder":"Loading_contentLoder__7IdlD"};